import apiClient from "./api.client.service";
import {
  OAuthClient,
  OAuthClientWithoutClientSecret,
} from "../Entities/OAuthClient";
import {
  CreateOAuthClientDto,
  UpdateOAuthClientDto,
} from "../Dto/OAuthClient.dto";

class OAuthClientService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async createOAuthClient(
    payload: CreateOAuthClientDto
  ): Promise<OAuthClient | null> {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/oauth/clients`,
        payload
      );
      return response.data;
    } catch (error: any) {
      console.error("Error creating OAuth client:", error);
      return null;
    }
  }

  async getOAuthClients(): Promise<OAuthClientWithoutClientSecret[]> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/oauth/clients`
      );
      return response.data || [];
    } catch (error: any) {
      console.error("Error getting OAuth client:", error);
      return [];
    }
  }

  async getOAuthClientById(id: string): Promise<OAuthClient | null> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/oauth/clients/${id}`
      );
      return response.data || null;
    } catch (error: any) {
      console.error("Error getting OAuth client by id:", error);
      return null;
    }
  }

  async updateOAuthClient(
    id: string,
    payload: UpdateOAuthClientDto
  ): Promise<OAuthClientWithoutClientSecret | null> {
    try {
      const response = await apiClient.put(
        `${this.APIBaseUrl}/admin/oauth/clients/${id}`,
        payload
      );
      return response.data || null;
    } catch (error: any) {
      console.error("Error updating OAuth client:", error);
      return null;
    }
  }
}

const oAuthClientService = new OAuthClientService();

export default oAuthClientService;
